//Asistencias
$(document).on('click','.abreAsistenciaModal', function(e){
    e.preventDefault();
    var id = $(this).data('id') || (this.id ? this.id.replace(/^[^\d]+/, '') : null);
    if (!id) return;

    $("#_method").val("PUT");
    $("#formAsistencia").attr('action',"/control-asistencia/"+id);
    $(".btnDeleteAsistencia").css("display","block");
    $(".btnDeleteAsistencia").data('id', id).attr('data-id', id);
    $(".campo").val("");

    $.ajax({
        url: "/control-asistencia/"+id,
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#fichaAsistenciaLabel").html("Edición de asistencia");
            $.each(data,function(index,value){
                if(value != null){
                    if(index == "user_id"){
                        $.ajax({
                            url: "/control-asistencia/empleados",
                            type: "GET",
                            dataType: "json",
                            success: function(value2){
                                $("#user_id").empty();
                                $("#user_id").append('<option value="" disabled selected>Selecciona un empleado</option>');
                                $.each(value2, function(index2, empleado) {
                                    if(empleado.id == data.user_id){
                                        $("#user_id").append('<option selected value="' + empleado.id + '">' + empleado.nombre + ' ' + empleado.apellidos + '</option>');
                                    }else{
                                        $("#user_id").append('<option value="' + empleado.id + '">' + empleado.nombre + ' ' + empleado.apellidos + '</option>');
                                    }
                                });
                            }
                        });
                    }else{
                        $("#"+index.toLowerCase()).val(value);
                    }
                }
            });
        }
    }); 
});

$(document).on('click','.nuevaAsistenciaModal', function(){
    $("#_method").val("POST");
    $("#formAsistencia").attr('action',"/control-asistencia");
    $("#fichaAsistenciaLabel").html("Registro de nueva asistencia");
    $(".btnDeleteAsistencia").css("display","none");
    $(".campo").val("");
    
    // Poner por defecto la fecha de hoy
    var today = new Date().toISOString().split('T')[0];
    $("#fecha_entrada").val(today);

    $.ajax({
        url: "/control-asistencia/empleados",
        type: "GET",
        dataType: "json",
        success: function(data){
            $("#user_id").empty();
            $("#user_id").append('<option value="" disabled selected>Selecciona un empleado</option>');
            $.each(data, function(index, empleado) {
                $("#user_id").append('<option value="' + empleado.id + '">' + empleado.nombre + ' ' + empleado.apellidos + '</option>');
            });
        }
    });
});

$(document).on('click','.btnDeleteAsistencia',function(e){
    e.preventDefault();
    var id = $(this).data('id') || (this.id ? this.id.replace(/^[^\d]+/, '') : null);
    if (!id) return;

    Swal.fire({
        title: "¿Deseas eliminar este registro de asistencia?",
        text: "Esta acción no se puede deshacer",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#c35560",
        cancelButtonColor: "#6c757d",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar"
    }).then((result) => {
        if (result.isConfirmed) {
            var directForm = document.getElementById('formdelete-' + id);
            if (directForm) {
                directForm.submit();
            } else {
                $("#_method").val("DELETE");
                $("#formAsistencia").attr('action', "/control-asistencia/" + id);
                $("#formAsistencia").submit();
            }
        }
    });
});

$(document).on('click','.fichaje', function(e){
    e.preventDefault();
    var id = $(this).data('id') || (this.id ? this.id.replace(/^[^\d]+/, '') : null);
    if (!id) return;

    var btn = $(this);
    btn.addClass('disabled pe-none');

    $.ajax({
        url: "/control-asistencia/fichaje/"+id,
        type: "GET",
        dataType: "json",
        success: function(data){
            if(data > 0){
                Swal.fire({
                    icon: "success",
                    title: "Fichaje registrado",
                    text: "Turno actualizado correctamente",
                    timer: 1300,
                    showConfirmButton: false
                });
                setTimeout(function(){ location.reload(); }, 1200);
            }
        },
        error: function(){
            btn.removeClass('disabled pe-none');
            Swal.fire("Error", "No se pudo registrar el fichaje", "error");
        }
    });
});
